import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Top-level 404 for any unmatched URL. Rendered OUTSIDE ProtectedRoute, so it shows
 * identically for authenticated and unauthenticated visitors — it holds NO session or
 * auth logic by design (HARDEN-CATCHALL-REDIRECT-1). The link points at the marketing
 * home, which offers tenant/vendor sign-in, rather than assuming any app route.
 */
export function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-base px-4">
      <div className="w-full max-w-sm text-center">
        <div className="mb-6 flex justify-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-bg-surface-2">
            <FileQuestion className="h-7 w-7 text-text-secondary" />
          </div>
        </div>
        <h1 className="text-xl font-bold text-text-primary">Page not found</h1>
        <p className="mt-3 text-sm text-text-secondary">
          The page you're looking for doesn't exist or may have moved. Check the address, or
          head back to VeriGRC.
        </p>
        <div className="mt-8 flex justify-center">
          <Button asChild>
            <a href="https://verigrc.com">Go to VeriGRC</a>
          </Button>
        </div>
      </div>
    </div>
  );
}
